"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.genColor = void 0;
var react_1 = __importDefault(require("react"));
var genColor = function (_a) {
    var color = _a.color;
    if (!color)
        return null;
    return (react_1.default.createElement("div", { style: { flex: "0 0 auto" } },
        react_1.default.createElement("div", { style: { width: '2rem', height: '2rem', background: color, borderRadius: '10%' } })));
};
exports.genColor = genColor;
